import { APPROVAL_PHASE } from "../approval-phase.types";
import { ORDER_APPROVAL_PHASE } from "@erp/shared/types/order-approval-phase.types";
import { PURCHASE_APPROVAL_PHASE } from "@erp/shared/types/purchase-approval-phase.types";
import { STOCK_APPROVAL_PHASE } from "@erp/shared/types/stock-approval-phase.types";
import { DocumentApprovalStatus } from "@erp/shared/types/approval-step.types";
// 승인 상태 관련 함수들 (enum 활용)
export function getApprovalChipColor(phase) {
    switch (phase) {
        case APPROVAL_PHASE.미확인:
        case STOCK_APPROVAL_PHASE.미확인:
        case PURCHASE_APPROVAL_PHASE.미승인:
        case ORDER_APPROVAL_PHASE.미승인:
        case DocumentApprovalStatus.DRAFT:
            return "default";
        case APPROVAL_PHASE.미승인:
        case STOCK_APPROVAL_PHASE.미승인:
        case DocumentApprovalStatus.IN_PROGRESS:
            return "amber lighten-4";
        case APPROVAL_PHASE.승인:
        case STOCK_APPROVAL_PHASE.승인:
        case ORDER_APPROVAL_PHASE.진행중:
        case PURCHASE_APPROVAL_PHASE.진행중:
            return "primary";
        case APPROVAL_PHASE.수주완료:
        case ORDER_APPROVAL_PHASE.구매완료:
        case PURCHASE_APPROVAL_PHASE.발주완료:
        case DocumentApprovalStatus.APPROVED:
            return "success";
        case APPROVAL_PHASE.반려:
        case STOCK_APPROVAL_PHASE.반려:
        case ORDER_APPROVAL_PHASE.반려:
        case PURCHASE_APPROVAL_PHASE.반려:
        case DocumentApprovalStatus.REJECTED:
            return "error";
        default:
            return "grey";
    }
}
